import React, { useEffect, useState } from 'react'
import { useMyContext } from "../Provider/CommonProvider"
import MessageLabel from './MessageLabel'
import { IconDocument, IconDownArrow, IconMyClose, IconMyNextArrow } from '../../Assets/MyIcons'
import { FaRegWindowMinimize } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { Link } from 'react-router-dom'
import MessageBox from './MessageBox';
const AdminUploadIndicator = ({ uploadingFiles }) => {
  const [open, setOpen] = useState(true)
  const [modalClose, setModalClose] = useState(true)
  const { retryUpload, cancelUpload, formatBytes, clearCompletedFiles, clearFile } = useMyContext()
  const handleToggle = () => [
    setOpen(prev => !prev)
  ]

  const handleModalClose = () => {
    setModalClose(false)
  }

  useEffect(() => {
    setModalClose(true)
  }, [uploadingFiles])


  const CircularProgress = ({ progress }) => {
    const radius = 50;
    const strokeWidth = 15;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (progress / 100) * circumference;
    return (
      <svg width={35} height={35} viewBox="0 0 120 120">
        <circle cx="60" cy="60" r={radius} stroke="#e6e6e6" strokeWidth={strokeWidth} fill="none" />
        <circle cx="60" cy="60" r={radius} stroke="#4db8ff" strokeWidth={strokeWidth} fill="none" strokeDasharray={circumference} strokeDashoffset={offset} />
        <text x="50%" y="50%" alignmentBaseline="middle" textAnchor="middle" fontSize="20px" fill="#333">
          {progress}%
        </text>
      </svg>
    );
  };
  return (
    uploadingFiles?.length > 0 && modalClose ? <div className={`theme-bg-color theme-border-button-color AdminUploadIndicator   pb-3 ${open ? 'overflow-scroll-indicator' : 'collapse-zone overflow-hidden-indicator'}`}>
      <div className='d-flex align-items-center p-3  theme-bg-color upload-indicator-header mb-3 justify-content-between border-bottom position-sticky theme-border-color'>
        <div className='d-flex align-items-center gap-2 '>
          {uploadingFiles.filter(file => file.status === 'completed').length > 0 && <div>
            <MessageLabel text={`Done (${uploadingFiles.filter(file => file.status === 'completed').length}) - `} noMargin />
            {/* <button onClick={clearCompletedFiles} className={"theme-text-color bg-transparent cursor-pointer speedText text-decoration-underline"} >Clear completed Files</button> */}
          </div>}
          {uploadingFiles.filter(file => file.status === 'uploading').length > 0 && <MessageLabel text={`Uploading (${uploadingFiles.filter(file => file.status === 'uploading').length}) - `} noMargin />}
          {uploadingFiles.filter(file => file.status === 'failed').length > 0 && <MessageLabel text={`Failed (${uploadingFiles.filter(file => file.status === 'failed').length})`} noMargin />}
        </div>
        <div className='d-flex align-items-center gap-2'>
          <button type='button' className='bg-transparent p-0' onClick={handleToggle}>{!open ? <IconDownArrow styled={{ className: "theme-text-color rotate-arrow", width: "20px", height: "20px" }} /> : <FaRegWindowMinimize className="theme-text-color" styled={{ className: "theme-text-color", width: "25px", height: "25px" }} />}</button>
          {(uploadingFiles.filter(file => file.status === 'completed').length == uploadingFiles?.length) ? <button type='button' className='bg-transparent p-0' onClick={handleModalClose}>{<IconMyClose className="theme-text-color" styled={{ className: "theme-text-color", width: "25px", height: "25px" }} />}</button> : ""}
        </div>
      </div>
      {uploadingFiles.map((fileItem, index) => (
        <div className=' px-3 d-flex align-items-center justify-content-between mb-3 ' key={index}>
          <div className='d-flex pt-2 align-items-center gap-2 position-relative'>
            <span className='from-indicator position-absolute  rounded-2'>{fileItem?.from}</span>
            <IconDocument styled={{ width: "20px", height: "20px", className: "" }} />
            <div className='indicator-width'>
              <p className='indicator-file-name'>{fileItem?.file?.name}</p>
              <div className='d-flex align-items-center justify-content-between'>
                {fileItem.status === "uploading" ?
                  <p className='speedText m-0'>Speed: {fileItem.speed ? formatBytes(fileItem.speed) + "/s" : "Calculating..."}</p>
                  : fileItem.status === "completed" ? <span className='speedText'>Upload Completed</span>
                    : fileItem.status === "failed" ? <span className='speedText'>Upload Failed</span>
                      : fileItem.status === "canceled" ? <span className='speedText'>Upload Canceled</span> : ""
                }
                <p className='sizeText m-0'>{formatBytes(fileItem?.file?.size)}</p>
              </div>
              {fileItem?.error ? <span className='speedText warningColor'>{fileItem?.error}</span> : ""}
            </div>
            {(fileItem.status === "completed") && (
              <>
                {fileItem?.from == "library" && <Link to={`/library`} className='indicatorButon d-flex align-items-center justify-content-between text-center py-1 px-2 successFull   mx-3  rounded-2 cancelText theme-button-text-color ' > <span>Lib</span> <IconMyNextArrow styled={{ width: "16px", height: "16px" }} />  </Link>}
                {fileItem?.from == "video" && <Link to={`/edit-video/${fileItem?.id ? fileItem?.id : ""}`} className=' indicatorButon d-flex align-items-center justify-content-between text-center py-1 px-2 successFull   mx-3  rounded-2 cancelText theme-button-text-color ' > <span>Next</span> <IconMyNextArrow styled={{ width: "16px", height: "16px" }} />  </Link>}
                {fileItem?.from == "live" && <div className=' indicatorButon d-flex align-items-center justify-content-center text-center py-1 px-2 successFull   mx-3  rounded-2 cancelText theme-button-text-color ' > <span>Done</span> </div>}
                {fileItem?.from == "audio" && <Link to={`/edit-audio/${fileItem?.id ? fileItem?.id : ""}`} className='indicatorButon d-flex align-items-center justify-content-between text-center py-1 px-2 successFull   mx-3  rounded-2 cancelText theme-button-text-color ' > <span>Next</span> <IconMyNextArrow styled={{ width: "16px", height: "16px" }} />  </Link>}
              </>
            )}
            {(fileItem.status === "uploading" || fileItem?.status === "pending") && (
              <button className='bg-transparent theme-text-color indicatorButon mx-3 theme-border-secondary rounded-2 cancelText ' onClick={() => cancelUpload(fileItem?.fileId)}>Cancel</button>
            )}
            {(fileItem?.status === "failed" || fileItem?.status === "canceled") ?
              <div>
                <button className='bg-transparent  theme-text-color  indicatorButon mx-3 theme-border-secondary rounded-2 cancelText ' onClick={() => retryUpload(fileItem?.fileId, "")}>Retry</button>
                <button className='bg-transparent px-2 theme-text-color' onClick={() => clearFile(fileItem?.fileId)}><MdClose style={{ width: "28px", height: "28px" }} /> </button>
              </div>
              : fileItem?.status == "completed" ? <button className='bg-transparent theme-text-color' onClick={() => clearFile(fileItem?.fileId)}><MdClose style={{ width: "28px", height: "28px" }} /> </button> : <div>
                <CircularProgress progress={fileItem?.progress} />
              </div>}
          </div>
        </div>
      ))}
    </div> : ""
  )
}

export default AdminUploadIndicator 